var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_c('div',[_c('div',{staticClass:"text-primary font-weight-bold"},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]),_c('div',[_vm._v(_vm._s(_vm.valueText? _vm.valueText : '-'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }